import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    question1: "",
    question2: "",
    question3: "",
    fspType: "",
    sCheck1: false, 
    sCheck2: false, 
    sCheck3: false,
    sCheck4: false, 
    sCheck5: false, 
    sCheck6: false,
    sCheck7: false, 
    sCheck8: false, 
    sCheck9: false,
    lCheck1: false, 
    lCheck2: false, 
    lCheck3: false,
    lCheck4: false, 
    lCheck5: false, 
    lCheck6: false,
    lCheck7: false, 
    lCheck8: false, 
    lCheck9: false,
    lCheck10: false, 
    lCheck11: false,
    iCheck1: false, 
    iCheck2: false, 
    iCheck3: false,
    iCheck4: false, 
    iCheck5: false, 
    iCheck6: false,
    iCheck7: false, 
    iCheck8: false, 
    iCheck9: false,
    iCheck10: false, 
    iCheck11: false,
    sCheck9Text: "",
    q3Check1: false, 
    q3Check2: false, 
    q3Check3: false,
    q3Check4: false, 
    q3Check5: false, 
    q3Check6: false,
    q3Check7: false,
    bnkState: [],
    coopState: [],
    microState: [],
    lfState: [],
    imState: [],
    maState: [],
    digiState: [],
    bnkRank: [],
    coopRank: [],
    microRank: [],
    lfRank: [],
    imRank: [],
    maRank: [],
    digiRank: [],
};

export const fpmSlice = createSlice({
    name: "fpm",
    initialState,
    reducers: {
        setFpmQuestion1: (state, action) => {
            state.question1 = action.payload;
        },

        unsetFpmQuestion1: (state) => {
            localStorage.clear();
            state.question1 = "";
        },

        setFpmQuestion2: (state, action) => {
            state.question2 = action.payload;
        },

        unsetFpmQuestion2: (state) => {
            localStorage.clear();
            state.question2 = "";
        },

        setFpmQuestion3: (state, action) => {
            state.question3= action.payload;
        },

        unsetFpmQuestion3: (state) => {
            localStorage.clear();
            state.question3 = "";
        },

        setFspType: (state, action) => {
            state.fspType = action.payload;
        },

        unsetFspType: (state) => {
            localStorage.clear();
            state.fspType = "";
        },

        setSavingsState: (state, action) => {
            state.sCheck1 = action.payload.sCheck1;
            state.sCheck2 = action.payload.sCheck2;
            state.sCheck3 = action.payload.sCheck3;
            state.sCheck4 = action.payload.sCheck4;
            state.sCheck5 = action.payload.sCheck5;
            state.sCheck6 = action.payload.sCheck6;
            state.sCheck7 = action.payload.sCheck7;
            state.sCheck8 = action.payload.sCheck8;
            state.sCheck9 = action.payload.sCheck9;
        },

        unSetSavingsState: (state) => {
            state.sCheck1 = false;
            state.sCheck2 = false;
            state.sCheck3 = false;
            state.sCheck4 = false;
            state.sCheck5 = false;
            state.sCheck6 = false;
            state.sCheck7 = false;
            state.sCheck8 = false;
            state.sCheck9 = false;
        },

        setLoansState: (state, action) => {
            state.lCheck1 = action.payload.lCheck1;
            state.lCheck2 = action.payload.lCheck2;
            state.lCheck3 = action.payload.lCheck3;
            state.lCheck4 = action.payload.lCheck4;
            state.lCheck5 = action.payload.lCheck5;
            state.lCheck6 = action.payload.lCheck6;
            state.lCheck7 = action.payload.lCheck7;
            state.lCheck8 = action.payload.lCheck8;
            state.lCheck9 = action.payload.lCheck9;
            state.lCheck10 = action.payload.lCheck10;
            state.lCheck11 = action.payload.lCheck11;
        },

        setInsurancesState: (state, action) => {
            state.iCheck1 = action.payload.iCheck1;
            state.iCheck2 = action.payload.iCheck2;
            state.iCheck3 = action.payload.iCheck3;
            state.iCheck4 = action.payload.iCheck4;
            state.iCheck5 = action.payload.iCheck5;
            state.iCheck6 = action.payload.iCheck6;
            state.iCheck7 = action.payload.iCheck7;
            state.iCheck8 = action.payload.iCheck8;
            state.iCheck9 = action.payload.iCheck9;
            state.iCheck10 = action.payload.iCheck10;
            state.iCheck11 = action.payload.iCheck11;
        },

        unSetLoansState: (state) => {
            state.lCheck1 = false;
            state.lCheck2 = false;
            state.lCheck3 = false;
            state.lCheck4 = false;
            state.lCheck5 = false;
            state.lCheck6 = false;
            state.lCheck7 = false;
            state.lCheck8 = false;
            state.lCheck9 = false;
            state.lCheck10 = false;
            state.lCheck11 = false;
        },

        setSavingOtherText: (state, action) => {
            state.sCheck9Text = action.payload;
        },

        unSetSavingOtherText: (state) => {
            localStorage.clear();
            state.sCheck9Text = "";
        },

        setQ3sState: (state, action) => {
            state.q3Check1 = action.payload.q3Check1;
            state.q3Check2 = action.payload.q3Check2;
            state.q3Check3 = action.payload.q3Check3;
            state.q3Check4 = action.payload.q3Check4;
            state.q3Check5 = action.payload.q3Check5;
            state.q3Check6 = action.payload.q3Check6;
            state.q3Check7 = action.payload.q3Check7;
        },

        unSetQ3sState: (state) => {
            state.q3Check1 = false;
            state.q3Check2 = false;
            state.q3Check3 = false;
            state.q3Check4 = false;
            state.q3Check5 = false;
            state.q3Check6 = false;
            state.q3Check7 = false;
        },

        setBnkState: (state, action) => {
            state.bnkState = action.payload;
        },

        setCoopState: (state, action) => {
            state.coopState = action.payload;
        },

        setMicroState: (state, action) => {
            state.microState = action.payload;
        },

        setLFState: (state, action) => {
            state.lfState = action.payload;
        },

        setIMState: (state, action) => {
            state.imState = action.payload;
        },

        setMAState: (state, action) => {
            state.maState = action.payload;
        },

        setDigiState: (state, action) => {
            state.digiState = action.payload;
        },

        setBnkRanks: (state, action) => {
            state.bnkRank = action.payload;
        },

        setCoopRanks: (state, action) => {
            state.coopRank = action.payload;
        },

        setMicroRanks: (state, action) => {
            state.microRank = action.payload;
        },

        setLFRanks: (state, action) => {
            state.lfRank = action.payload;
        },

        setIMRanks: (state, action) => {
            state.imRank = action.payload;
        },

        setMARanks: (state, action) => {
            state.maRank = action.payload;
        },

        setDigiRanks: (state, action) => {
            state.digiRank = action.payload;
        },



    }
});

export const {
    setFpmQuestion1,
    setFpmQuestion2,
    setFpmQuestion3,
    setFspType,
    unsetFspType,
    unsetFpmQuestion1,
    unsetFpmQuestion2,
    unsetFpmQuestion3,
    setSavingsState,
    unSetSavingsState,
    setQ3sState,
    unSetQ3sState,
    setSavingOtherText,
    unSetSavingOtherText,
    setBnkState,
    setCoopState,
    setMicroState,
    setLFState,
    setIMState,
    setMAState,
    setDigiState,
    setBnkRanks,
    setCoopRanks,
    setMicroRanks,
    setLFRanks,
    setIMRanks,
    setMARanks,
    setDigiRanks,
    setLoansState,
    unSetLoansState,
    setInsurancesState,
} = fpmSlice.actions;

export default fpmSlice.reducer;